import { Editor, type EditorEvent, type Events, type Ui } from 'tinymce';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import { MediaControlService } from '@medsurf/flat-services';
import * as BasePlugin from '../base/media.base.plugin.editor';


export const register = (
  editor: Editor,
  zone: NgZone,
  translate: TranslateService,
  dialogService: DialogService,
  mediaControlService: MediaControlService
) => {
  const nodeChangedCallback = (
		buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi, 
		event: EditorEvent<Events.NodeChangeEvent>
	) => {
    const element = (<HTMLElement>event.element);
    const isVideo = element?.tagName?.toLowerCase() === 'video' || element?.dataset['mceObject'] === 'video';

    buttonApi.setEnabled(isVideo || editor.selection.getContent() === '');
    buttonApi.setActive(isVideo);
  }

  const onSetup = (buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi) => {
    editor.on('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    return () => {
      editor.off('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    };
  };

  const onAction = () => {
    const allowedTypes: FlatModels.MediaEntityModels.MediaType[] = [FlatModels.MediaEntityModels.MediaType.enum.MediaVideo];

    const node = <HTMLElement>editor.selection.getNode();
    const isVideo = node?.tagName?.toLowerCase() === 'video';
    const id = node.dataset['id'];

    const selected: FlatModels.ModalAuthorModels.SelectedMediaDialogItem | undefined =
      isVideo && id ? { id, type: FlatModels.MediaEntityModels.MediaType.enum.MediaVideo } : undefined;

    try {
      zone.run(async () => {

        editor.editorManager.focusedEditor = null; 
        const media = await BasePlugin.openMediaDialog(
          translate.instant('global.video_edit'),
          dialogService,
          allowedTypes,
          selected
        )
        editor.editorManager.focusedEditor = editor;

        if (!media) return;
        const url = mediaControlService.getEditorUrl(media);
            
        if (isVideo) {
          editor.dom.setAttribs(node, {
            src: url,
            'data-id': media.id,
            'data-mce-src': url
          });
          editor.dispatch('change');
        } else {
          const node: HTMLVideoElement = document.createElement('video');
          node.setAttribute('src', url);
          node.setAttribute('data-id', media.id);
          node.setAttribute('controls', '');
          node.setAttribute('controlsList', 'nodownload');
          editor.insertContent(node.outerHTML);
        }
      });
    } catch (err) {
      return;
    }
  }

  editor.ui.registry.addToggleButton('mediavideo', {
    icon: 'video',
    tooltip: 'Insert/edit video',
    onAction,
    onSetup
  });
}

